<template>   
  <div>
    <component :is="currentHeaderComponent"></component>  
    <router-view></router-view>
    <component :is="currentFooterComponent"></component>   
  </div>
</template>

<script>
import Header from './components/layout/Header'
import Footer from './components/layout/Footer'
import AdminHeader from './components/admin/layout/AdminHeader'
import AdminFooter from './components/admin/layout/AdminFooter'
import 'vue-flash-message/dist/vue-flash-message.min.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import { getDataFromServer } from './components/utils/DataProvider'
import { InitSource } from './components/sources/language_provider'

export default {
  data: () => {
    return{
      isLoaded: false,
      currentHeader: 'Header'        
    }
  },
  name: 'Girudo',
  components: {
    Header,
    Footer,
    AdminHeader,
    AdminFooter,   
  },
  computed:{
    currentHeaderComponent: function(){
      return this.$route.meta.layout === 'default' ? 'Header' : 'AdminHeader'
    },
    currentFooterComponent: function(){
      console.log("currentFooterComponent ", this.$route.meta.layout)
      console.log("currentFooterComponent ", this.$route.meta.layout === 'default' ? 'Footer' : 'AdminFooter')
      return this.$route.meta.layout === 'default' ? 'Footer' : 'AdminFooter'
    }
  }, 
  created(){
    //get site data
    console.log("get site data APP **************** ")
    this.isLoaded = false
    getDataFromServer('get_homepage_data', null)
    .then(obj => {
      console.log("get site data ****************", obj)
      
      if(this.$store.getters.CURRENT_LANGUAGE === ''){
        this.$store.dispatch('SET_CURRENT_LANGUAGE', obj.data.config.data.language)       
        InitSource(obj.data.config.data.language, this.$store)
      }else{
        obj.data.config.data.language = this.$store.getters.CURRENT_LANGUAGE
        this.$store.dispatch('INIT_SITE_DATA', obj.data)
        InitSource(this.$store.getters.CURRENT_LANGUAGE, this.$store)
      }     
      
      this.isLoaded = true
      console.log("get site data loaded ****************", this.isLoaded)
    })
    .catch(err => { this.flash('get site data error: ' + err, 'error', {timeout: 4500}) }) 
  }, 
}
</script>


<style>
@import './assets/css/bootstrap.min.css';
@import './assets/font-awesome/css/font-awesome.min.css';
@import './assets/plugins/cubeportfolio/css/cubeportfolio.min.css';
@import './assets/css/nivo-lightbox.css';
@import './assets/css/nivo-lightbox-theme/default/default.css';
@import './assets/css/owl.carousel.css';
@import './assets/css/owl.theme.css';
@import './assets/css/animate.css';
@import './assets/css/style.css';
@import './assets/css/default.css';
@import './assets/css/admin-style.css';

.flash-message-top-container{
  background-color: unset !important;
    border: unset !important;
    position: fixed;
    top: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 2
}

.flash-message-top{
  width: 20%;
}

.span-valid-text{
  color: red;
}

label.requered:after{
  content:" *";
  color: red;
}

.d-flex{
    display: flex;
  }

form{
  margin-top: 20px;
}

form button{
  margin-top: 40px;
}  

.label-left{
  text-align: left !important;    
}

.label-left label{
  margin-left: 5px;
  font-size: 14px;
  font-weight: normal;
}

.label-right{
  text-align: right !important;    
}

.label-right label{
  margin-right: 5px;
  font-size: 14px;
  font-weight: normal;
}

.d-none{
  display: none;
}

.d-block{
  display: block;
}

.btn:focus, 
.btn:active:focus, 
.btn.active:focus, 
.btn.focus, 
.btn:active.focus, 
.btn.active.focus{
  outline: none !important;
}

.slick-prev:before, 
.slick-next:before{
  color: #3fbbc0 !important;
}

</style>
